import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { Reassurance } from "@/components/home/Reassurance";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { Realisations } from "@/components/home/Realisations";
import { Method } from "@/components/home/Method";
import { Stats } from "@/components/home/Stats";
import { ZonesSection } from "@/components/home/ZonesSection";
import { Testimonials } from "@/components/home/Testimonials";
import { HomeFaq, HOME_FAQ } from "@/components/home/HomeFaq";
import { CtaFinal } from "@/components/CtaFinal";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: HOME_FAQ.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <Seo
        title="Ravalement façade Dordogne | HRC Rénovation — Devis 48h"
        description="Ravalement de façade, nettoyage hydrofuge et peinture à Périgueux et en Dordogne. Devis gratuit sous 48h. ☎ 06 41 96 83 46."
        jsonLd={[faqLd]}
      />
      <Hero />
      <Reassurance />
      <ServicesGrid />
      <Realisations />
      <Method />
      <Stats />
      <ZonesSection />
      <Testimonials />
      <HomeFaq />
      <CtaFinal />
    </>
  );
}
